import Vue from 'vue'
import VueRouter from 'vue-router'
import PortalLayout from "@/components/portal/PortalLayout";
import ManagerLayout from "@/components/manager/ManagerLayout";
// import { MessageBox } from 'element-ui';
// import {getLocalBank} from "@/utils/storage";
// import config from "@/config";

//
// import store from "@/store";

import NProgress from 'nprogress';
import 'nprogress/nprogress.css';
NProgress.configure({
  easing: 'ease',  // 动画方式
  speed: 500,  // 递增进度条的速度
  showSpinner: false, // 是否显示加载ico
  trickleSpeed: 200, // 自动递增间隔
  minimum: 0.3 // 初始化时的最小百分比
})


Vue.use(VueRouter)

// 门户路由组
import portalRoute from "@/router/portal.route";
import managerRoute from "@/router/manager.route";
const routes = [
  {
    path: '/',
    name: 'portal',
    component: PortalLayout,
    redirect: '/home',
    children: [...portalRoute],
  },
  {
    path: '/manager',
    name: 'manager',
    component: ManagerLayout,
    redirect: '/manager/profile',
    children: [...managerRoute],
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior () {
    return {
      x: 0,
      y: 0,
      // behavior: 'smooth',
    }
  }
});

/**
 * 路由守卫
 */
// const LOCAL_TOKEN_SYMBOL = `${config.storagePre}_LOGIN_TOKEN`;

router.beforeEach((to, from, next) => {
  NProgress.start();
  // const {fullPath} = to;
  // const logged = store.getters['auth/logged'] || !!getLocalBank(LOCAL_TOKEN_SYMBOL);
  // if(fullPath.includes('manager')) {
  //   if(logged) {
  //     next();
  //   } else {
  //     MessageBox.alert('您无权访问当前页面，即将为您跳转至首页', '无权访问',{
  //       confirmButtonText: '确定',
  //       callback: () => {
  //         next({
  //           name: 'portalHome',
  //         });
  //       }
  //     });
  //   }
  // } else {
  //   next();
  // }
  next();
});


router.afterEach(() => {
  NProgress.done();
})

export default router
